import ToggleableButton from "../../../../../components/toggleableButton/toggleableButton";
import {connect} from "react-redux";
import {actionCreators} from "../redux/sagas/activeClientsSagas";

export default connect(
  state => ({
    isActive: state.activeClientsReducer.selectedFilters.compare,
    isRadio: true,
    title: "active-clients-compare-dates"
  }),
  {onClick: data => actionCreators.updateCompareDates(data)}
)(ToggleableButton);
